<a (click)="openImageViewer(value)">
     <img [src]="value"
          data-cy="image"
          class="datex-image"
          [ngStyle]="styles.style"
          [ngClass]="styles.classes"
          onerror="this.style.display='none'"
          onload="this.style.display='inline'" />
</a>